/* unplugin-vue-components disabled */import { render } from "./InfoBlock.vue?vue&type=template&id=31e86884&scoped=true"
import script from "./InfoBlock.vue?vue&type=script&lang=js"
export * from "./InfoBlock.vue?vue&type=script&lang=js"

import "./InfoBlock.vue?vue&type=style&index=0&id=31e86884&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e86884"]])

export default __exports__